<template>
<div>
    <div class="selectTypeBox">
        <el-radio-group v-model="selectType" @change="onChangeSelectType">
            <el-radio-button label="全部"></el-radio-button>
            <el-radio-button label="认证成功"></el-radio-button>
            <el-radio-button label="待认证"></el-radio-button>
        </el-radio-group>
    </div>
    <div style="width: 80%; margin: 15px auto 15px auto">
        <el-input placeholder="请输入用户姓名进行搜索" v-model="positionName" class="input-with-select" @change="changePostionName">
            <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
    </div>
    <div class="itemList">
        <div class="itemDiv" v-for="item in dataList" :key="item.id">

        </div>
    </div>
    <div class="itemList">
        <div class="itemDiv">
            <div class="logoBox">
                <img src="../assets/logo.png"></img>
            </div>
            <div class="companyInfoBox">
                <div>公司名称: XXXXXXXX (简称)</div>
                <div>联系人名称: XXX</div>
                <div>联系人电话: 139XXXXXXX</div>
                <div>联系人邮箱: XXXX@XX.com</div>
            </div>
            <div @click="showCompanyAudit" class="companyAudit" data-src="https://gss2.bdstatic.com/9fo3dSag_xI4khGkpoWK1HF6hhy/baike/c0%3Dbaike272%2C5%2C5%2C272%2C90/sign=1ad8b8813c7adab429dd1311eabdd879/562c11dfa9ec8a1381e65c49fd03918fa1ecc09f.jpg">
                <div class="imageAction">
                    <img  src="https://gss2.bdstatic.com/9fo3dSag_xI4khGkpoWK1HF6hhy/baike/c0%3Dbaike272%2C5%2C5%2C272%2C90/sign=1ad8b8813c7adab429dd1311eabdd879/562c11dfa9ec8a1381e65c49fd03918fa1ecc09f.jpg" />
                </div>
                <div class="textAction">
                    统一社会信用保障码<br/>XXXXXXXXXXXXXXXX
                </div>
            </div>
            <div class="actionBox">
                <el-button type="success" icon="el-icon-check" circle></el-button>
                <el-button type="danger" icon="el-icon-close" circle></el-button>
                <el-button type="info" icon="el-icon-minus" circle></el-button>
            </div>
        </div>
    </div>
    <div class="imgShadow" v-if="ckMode">
        <div class="close" @click="hideCompanyAudit">
            <el-button icon="el-icon-close" circle></el-button>
        </div>
        <img  src="https://gss2.bdstatic.com/9fo3dSag_xI4khGkpoWK1HF6hhy/baike/c0%3Dbaike272%2C5%2C5%2C272%2C90/sign=1ad8b8813c7adab429dd1311eabdd879/562c11dfa9ec8a1381e65c49fd03918fa1ecc09f.jpg" />
        <div class="textAction">
                    统一社会信用保障码<br/>XXXXXXXXXXXXXXXX
        </div>
        <div class="actionBox">
            <el-button type="success" icon="el-icon-check" circle></el-button>
            <el-button type="danger" icon="el-icon-close" circle></el-button>
            <el-button type="info" icon="el-icon-minus" circle></el-button>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios'
import Config from '../config/index'
export default {
    name: 'personAudit',
    props: {},
    data () {
        return {
            positionName: '',
            pageSize: 20,
            pageNumber: 1,
            pageTotal: 0,
            dataList: [],
            setid: '',
            selectType: '全部',
            ckMode: false

        }
    },
    methods: {
        changePostionName: function () {
            this.pageNumber = 1
        },
        onChangeSelectType () {
            
        },
        showCompanyAudit: function () {
            this.ckMode = true
        },
        hideCompanyAudit: function () {
            this.ckMode = false
        }
    },
    mounted: function () {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
    .itemList{
        margin-top: 20px;
    }

    .itemList .itemDiv{
        background-color: #ffffff;
        width: 80%;
        margin: 0 auto 15px auto;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
        padding: 25px;
        border-radius: 8px;
        min-height: 200px;
        box-shadow: 10px 10px 10px rgba(0,0,0,0.5);
        position: relative;
    }

    .itemList .itemDiv .logoBox{

    }

    .itemList .itemDiv .logoBox img{
        width: 80px;
        height: 80px;
        border-radius: 8px;
    }

    .itemList .itemDiv .companyInfoBox{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        min-height: 200px;
        margin-left: 30px;
        color: #909399;
    }

    .itemList .itemDiv .companyAudit{
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        min-height: 200px;
        position: absolute;
        right: 130px;
    } 

    .itemList .itemDiv .companyAudit .imageAction{
        
    }

    .itemList .itemDiv .companyAudit .imageAction img{
        width: 110px;
    }

    .itemList .itemDiv .companyAudit .textAction{
        font-size: 12px;
        color: rgb(123,123,123);
        text-align: center;
    }
    
    .itemList .itemDiv .actionBox{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        min-height: 200px;
        position: absolute;
        right: 40px;
    }

    .itemList .itemDiv .actionBox button{
        margin: 0;
    }

    .imgShadow{
        width: 100vw;
        height: 100vh;
        position: fixed;
        background-color: rgba(0,0,0,0.7);
        top: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .imgShadow img{
        width: 500px;
    }
    
    .imgShadow .textAction{
        color: #ffffff;
        padding: 20px 0;
        text-align: center;
    }

    .imgShadow .actionBox{
        
    }

    .imgShadow .close{
        position: absolute;
        top: 30px;
        right: 30px;
    }
</style>
